module.exports = __webpack_public_path__ + "img/logo.563c0aa8.svg";